import { c as _c } from "react/compiler-runtime";
import { useId } from 'react';
import { Controller, type ControllerProps, type FieldValues, type Path, useFormContext } from 'react-hook-form';
import MarkdownEditor, { type MarkdownEditorProps } from '../../markdown-editor';
import FormLabel, { type LabelTooltipProps } from '../internals/form-label';
import FormWrapper from '../internals/form-wrapper';
export type FormMarkdownEditorProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  label?: string | React.ReactNode;
  rules?: ControllerProps<TFieldValues>['rules'];
  hint?: string;
  tooltip?: LabelTooltipProps;
  size?: 'default' | 'compact';
  errorPosition?: 'absolute' | 'relative';
} & Omit<MarkdownEditorProps, 'value' | 'onChange' | 'onBlur' | 'ref' | 'hasError'>;
export default function FormMarkdownEditor(t0) {
  const $ = _c(23);
  let editorProps;
  let hint;
  let label;
  let name;
  let rules;
  let t1;
  let t2;
  let tooltip;
  if ($[0] !== t0) {
    ({
      name,
      label,
      rules,
      hint,
      tooltip,
      size: t1,
      errorPosition: t2,
      ...editorProps
    } = t0);
    $[0] = t0;
    $[1] = editorProps;
    $[2] = hint;
    $[3] = label;
    $[4] = name;
    $[5] = rules;
    $[6] = t1;
    $[7] = t2;
    $[8] = tooltip;
  } else {
    editorProps = $[1];
    hint = $[2];
    label = $[3];
    name = $[4];
    rules = $[5];
    t1 = $[6];
    t2 = $[7];
    tooltip = $[8];
  }
  const size = t1 === undefined ? "default" : t1;
  const errorPosition = t2 === undefined ? "relative" : t2;
  const {
    control,
    formState: t3
  } = useFormContext();
  const {
    disabled
  } = t3;
  const contextId = useId();
  let t4;
  if ($[9] !== contextId || $[10] !== disabled || $[11] !== editorProps || $[12] !== errorPosition || $[13] !== hint || $[14] !== label || $[15] !== size || $[16] !== tooltip) {
    t4 = t5 => {
      const {
        field,
        fieldState
      } = t5;
      const hasError = !!fieldState.error;
      const errorMessage = fieldState.error?.message;
      return <FormWrapper id={contextId} error={errorMessage} errorPosition={errorPosition} size={size} hint={hint} fullWidth={true} disabled={editorProps.disabled || disabled}><MarkdownEditor {...editorProps} label={label && <FormLabel hasError={hasError} htmlFor={contextId} size={size} tooltip={tooltip}>{label}</FormLabel>} value={field.value ?? ""} onChange={val => {
          field.onChange(val);
        }} onBlur={field.onBlur} disabled={field.disabled || editorProps.disabled || disabled} hasError={hasError} /></FormWrapper>;
    };
    $[9] = contextId;
    $[10] = disabled;
    $[11] = editorProps;
    $[12] = errorPosition;
    $[13] = hint;
    $[14] = label;
    $[15] = size;
    $[16] = tooltip;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== control || $[19] !== name || $[20] !== rules || $[21] !== t4) {
    t5 = <Controller name={name} control={control} rules={rules} render={t4} />;
    $[18] = control;
    $[19] = name;
    $[20] = rules;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  return t5;
}